// extracted by mini-css-extract-plugin
export default {"editBtn":"CoveragePreferences_editBtn__Go35n","coveragePrefHead":"CoveragePreferences_coveragePrefHead__eVp1G"};